import { render, staticRenderFns } from "./Sintomatologia.vue?vue&type=template&id=191a2e7e"
import script from "./Sintomatologia.vue?vue&type=script&lang=js"
export * from "./Sintomatologia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports